import { Moon, Sun, Monitor } from 'lucide-react';
import { useDarkMode } from '@/hooks/useDarkMode';
import { cn } from '@/lib/utils';

const OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
] as const;

/**
 * Compact icon-only theme switcher (light / dark / system) backed by
 * useDarkMode, so the choice persists in localStorage and applies the `.dark`
 * class to <html> immediately. Designed to live inside the user menu popover.
 */
export function ThemeToggle() {
  const [theme, setTheme] = useDarkMode();

  return (
    <div
      className="inline-flex items-center gap-0.5 rounded-md bg-gray-100 dark:bg-gray-800 p-0.5"
      data-testid="theme-toggle"
    >
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          onClick={() => setTheme(value)}
          aria-pressed={theme === value}
          aria-label={`${label} theme`}
          title={label}
          data-testid={`theme-option-${value}`}
          className={cn(
            'flex h-6 w-6 items-center justify-center rounded transition-colors',
            theme === value
              ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-700 dark:text-gray-100'
              : 'text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100'
          )}
        >
          <Icon className="h-3.5 w-3.5" />
        </button>
      ))}
    </div>
  );
}
